"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classnames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var week_1 = require("./week");
var date_fns_1 = require("date-fns");
var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
var Month = /** @class */ (function (_super) {
    __extends(Month, _super);
    function Month() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleDayClick = function (day, event) {
            if (_this.props.onDayClick) {
                _this.props.onDayClick(day, event);
            }
        };
        _this.handleDayMouseEnter = function (day) {
            if (_this.props.onDayMouseEnter) {
                _this.props.onDayMouseEnter(day);
            }
        };
        _this.handleMouseLeave = function () {
            if (_this.props.onMouseLeave) {
                _this.props.onMouseLeave();
            }
        };
        _this.isWeekInMonth = function (startOfWeek) {
            var day = _this.props.day;
            var endOfWeek = date_fns_1.addDays(startOfWeek, 6);
            return date_fns_1.isSameMonth(startOfWeek, day) || date_fns_1.isSameMonth(endOfWeek, day);
        };
        _this.renderWeeks = function () {
            var weeks = [];
            var isFixedHeight = _this.props.fixedHeight;
            var currentWeekStart = date_fns_1.startOfWeek(date_fns_1.startOfMonth(_this.props.day), {
                weekStartsOn: 1
            });
            var i = 0;
            var breakAfterNextPush = false;
            while (true) {
                weeks.push(React.createElement(week_1.default, { key: i, day: currentWeekStart, month: date_fns_1.getMonth(_this.props.day), onDayClick: _this.handleDayClick, onDayMouseEnter: _this.handleDayMouseEnter, minDate: _this.props.minDate, maxDate: _this.props.maxDate, inline: _this.props.inline, highlightDates: _this.props.highlightDates, includeDates: _this.props.includeDates, excludeDates: _this.props.excludeDates, filterDate: _this.props.filterDate, selectingDate: _this.props.selectingDate, preSelection: _this.props.preSelection, selected: _this.props.selected, selectsStart: _this.props.selectsStart, selectsEnd: _this.props.selectsEnd, showWeekNumber: _this.props.showWeekNumbers, startDate: _this.props.startDate, endDate: _this.props.endDate }));
                if (breakAfterNextPush) {
                    break;
                }
                i++;
                currentWeekStart = date_fns_1.addWeeks(currentWeekStart, 1);
                // If one of these conditions is true, we will either break on this week
                // or break on the next week
                var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
                var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
                if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
                    if (_this.props.peekNextMonth) {
                        breakAfterNextPush = true;
                    }
                    else {
                        break;
                    }
                }
            }
            return weeks;
        };
        _this.getClassNames = function () {
            var _a = _this.props, selectingDate = _a.selectingDate, selectsStart = _a.selectsStart, selectsEnd = _a.selectsEnd;
            return classnames('ee_react-datepicker__month', {
                'ee_react-datepicker__month--selecting-range': selectingDate && (selectsStart || selectsEnd)
            });
        };
        return _this;
    }
    Month.prototype.render = function () {
        return (React.createElement("div", { className: this.getClassNames(), onMouseLeave: this.handleMouseLeave, tabIndex: 0, role: "listbox" }, this.renderWeeks()));
    };
    Month.displayName = 'Month';
    Month.propTypes = {
        day: PropTypes.object.isRequired,
        endDate: PropTypes.object,
        fixedHeight: PropTypes.bool,
        minDate: PropTypes.object,
        maxDate: PropTypes.object,
        highlightDates: PropTypes.array,
        filterDate: PropTypes.func,
        excludeDates: PropTypes.array,
        includeDates: PropTypes.array,
        inline: PropTypes.bool,
        onDayClick: PropTypes.func,
        onDayMouseEnter: PropTypes.func,
        onMouseLeave: PropTypes.func,
        peekNextMonth: PropTypes.bool,
        preSelection: PropTypes.object,
        selected: PropTypes.object,
        selectingDate: PropTypes.object,
        selectsEnd: PropTypes.bool,
        selectsStart: PropTypes.bool,
        showWeekNumbers: PropTypes.bool,
        startDate: PropTypes.object
    };
    return Month;
}(React.Component));
exports.Month = Month;
exports.default = Month;
//# sourceMappingURL=month.js.map